/* Copyright (c) 2022 Xperi. All Rights Reserved. */

// TODO: We need to move this to some common place as it is also used in KeyBoardEvents.ts
interface CustomKeyPressedEvent {
    type: string;
    code: number;
    key: string;
}

export class Keys {
    // List of supported keyboard keys.

    static KEYBOARD_KEY_0: string = '0';

    static KEYBOARD_KEY_1: string = '1';

    static KEYBOARD_KEY_2: string = '2';

    static KEYBOARD_KEY_3: string = '3';

    static KEYBOARD_KEY_4: string = '4';

    static KEYBOARD_KEY_5: string = '5';

    static KEYBOARD_KEY_6: string = '6';

    static KEYBOARD_KEY_7: string = '7';

    static KEYBOARD_KEY_8: string = '8';

    static KEYBOARD_KEY_9: string = '9';

    static KEYBOARD_KEY_ADVANCE: string = 'a';

    static KEYBOARD_KEY_BACK: string = 'escape';

    static KEYBOARD_KEY_CHANNEL_DOWN: string = ',';

    static KEYBOARD_KEY_CHANNEL_UP: string = '.';

    static KEYBOARD_KEY_COLOR_BLUE: string = 'd';

    static KEYBOARD_KEY_DASH: string = '-';

    static KEYBOARD_KEY_DOWN: string = 'arrowdown';

    static KEYBOARD_KEY_EXIT: string = 'x';

    static KEYBOARD_KEY_FAST_FORWARD: string = 'f';

    static KEYBOARD_KEY_GUIDE: string = 'g';

    static KEYBOARD_KEY_INFO: string = 'i';

    static KEYBOARD_KEY_LEFT: string = 'arrowleft';

    static KEYBOARD_KEY_OK: string = 'enter';

    static KEYBOARD_KEY_PAUSE: string = ' ';

    static KEYBOARD_KEY_PLAY_PAUSE: string = 'o';

    static KEYBOARD_KEY_PLAY: string = 'p';

    static KEYBOARD_KEY_REPLAY: string = 'e';

    static KEYBOARD_KEY_REWIND: string = 'r';

    static KEYBOARD_KEY_RIGHT: string = 'arrowright';

    static KEYBOARD_KEY_STOP: string = 's';

    static KEYBOARD_KEY_TIVO: string = 't';

    static KEYBOARD_KEY_UP: string = 'arrowup';

    static LG_MOUSE_MODE_ON: number = 1536;

    static LG_MOUSE_MODE_OFF: number = 1537;

    static LG_REMOTE_KEY_CHANNEL_DOWN: string = 'pagedown';

    static LG_REMOTE_KEY_CHANNEL_UP: string = 'pageup';

    static LG_REMOTE_KEY_CODE_COLOR_BLUE: number = 406;

    static LG_REMOTE_KEY_CODE_MEDIA_FAST_FORWARD: number = 417;

    static LG_REMOTE_KEY_CODE_MEDIA_PAUSE: string = '\x85';

    static LG_REMOTE_KEY_CODE_MEDIA_PLAY: number = 415;

    static LG_REMOTE_KEY_CODE_MEDIA_REWIND: number = 412;

    static LG_REMOTE_KEY_CODE_MEDIA_STOP: number = 413;

    static LG_REMOTE_KEY_CODE_RETURN: number = 461;

    static SAMSUNG_REMOTE_KEY_0: string = '0';

    static SAMSUNG_REMOTE_KEY_1: string = '1';

    static SAMSUNG_REMOTE_KEY_2: string = '2';

    static SAMSUNG_REMOTE_KEY_3: string = '3';

    static SAMSUNG_REMOTE_KEY_4: string = '4';

    static SAMSUNG_REMOTE_KEY_5: string = '5';

    static SAMSUNG_REMOTE_KEY_6: string = '6';

    static SAMSUNG_REMOTE_KEY_7: string = '7';

    static SAMSUNG_REMOTE_KEY_8: string = '8';

    static SAMSUNG_REMOTE_KEY_9: string = '9';

    static SAMSUNG_REMOTE_KEY_CHANNEL_DOWN: string = 'xf86lowerchannel';

    static SAMSUNG_REMOTE_KEY_CHANNEL_UP: string = 'xf86raisechannel';

    static SAMSUNG_REMOTE_KEY_COLOR_BLUE: string = 'xf86blue';

    static SAMSUNG_REMOTE_KEY_EXIT: string = 'xf86exit';

    static SAMSUNG_REMOTE_KEY_GUIDE: string = 'xf86channelguide';

    static SAMSUNG_REMOTE_KEY_MEDIA_FAST_FORWARD: string = 'xf86audionext';

    static SAMSUNG_REMOTE_KEY_MEDIA_INFO: string = 'xf86info';

    static SAMSUNG_REMOTE_KEY_MEDIA_PAUSE: string = 'xf86audiopause';

    static SAMSUNG_REMOTE_KEY_MEDIA_PLAY_PAUSE: string = 'xf86playback';

    static SAMSUNG_REMOTE_KEY_MEDIA_PLAY: string = 'xf86audioplay';

    static SAMSUNG_REMOTE_KEY_MEDIA_REWIND: string = 'xf86audiorewind';

    static SAMSUNG_REMOTE_KEY_MEDIA_STOP: string = 'xf86audiostop';

    static SAMSUNG_REMOTE_KEY_MEDIA_TRACK_NEXT: string = 'xf86audionext';

    static SAMSUNG_REMOTE_KEY_MEDIA_TRACK_PREVIOUS: string = 'xf86audiorewind';

    static SAMSUNG_REMOTE_KEY_RETURN: string = 'xf86back';

    static KEYCODES: Record<string, string> = {
        [Keys.KEYBOARD_KEY_0]: 'KEYCODE_NUM_0',
        [Keys.KEYBOARD_KEY_1]: 'KEYCODE_NUM_1',
        [Keys.KEYBOARD_KEY_2]: 'KEYCODE_NUM_2',
        [Keys.KEYBOARD_KEY_3]: 'KEYCODE_NUM_3',
        [Keys.KEYBOARD_KEY_4]: 'KEYCODE_NUM_4',
        [Keys.KEYBOARD_KEY_5]: 'KEYCODE_NUM_5',
        [Keys.KEYBOARD_KEY_6]: 'KEYCODE_NUM_6',
        [Keys.KEYBOARD_KEY_7]: 'KEYCODE_NUM_7',
        [Keys.KEYBOARD_KEY_8]: 'KEYCODE_NUM_8',
        [Keys.KEYBOARD_KEY_9]: 'KEYCODE_NUM_9',
        [Keys.KEYBOARD_KEY_ADVANCE]: 'KEYCODE_ADVANCE',
        [Keys.KEYBOARD_KEY_BACK]: 'KEYCODE_RETURN',
        [Keys.KEYBOARD_KEY_CHANNEL_DOWN]: 'KEYCODE_CHANNEL_DOWN',
        [Keys.KEYBOARD_KEY_CHANNEL_UP]: 'KEYCODE_CHANNEL_UP',
        [Keys.KEYBOARD_KEY_COLOR_BLUE]: 'KEYCODE_COLOR_BLUE',
        [Keys.KEYBOARD_KEY_DASH]: 'KEYCODE_DASH',
        [Keys.KEYBOARD_KEY_DOWN]: 'KEYCODE_DOWN',
        [Keys.KEYBOARD_KEY_EXIT]: 'KEYCODE_EXIT',
        [Keys.KEYBOARD_KEY_FAST_FORWARD]: 'KEYCODE_MEDIA_FAST_FORWARD',
        [Keys.KEYBOARD_KEY_GUIDE]: 'KEYCODE_GUIDE',
        [Keys.KEYBOARD_KEY_INFO]: 'KEYCODE_MEDIA_INFO',
        [Keys.KEYBOARD_KEY_LEFT]: 'KEYCODE_LEFT',
        [Keys.KEYBOARD_KEY_OK]: 'KEYCODE_OK',
        [Keys.KEYBOARD_KEY_PAUSE]: 'KEYCODE_MEDIA_PAUSE',
        [Keys.KEYBOARD_KEY_PLAY_PAUSE]: 'KEYCODE_MEDIA_PLAY_PAUSE',
        [Keys.KEYBOARD_KEY_PLAY]: 'KEYCODE_MEDIA_PLAY',
        [Keys.KEYBOARD_KEY_REPLAY]: 'KEYCODE_REPLAY',
        [Keys.KEYBOARD_KEY_REWIND]: 'KEYCODE_MEDIA_REWIND',
        [Keys.KEYBOARD_KEY_RIGHT]: 'KEYCODE_RIGHT',
        [Keys.KEYBOARD_KEY_STOP]: 'KEYCODE_MEDIA_STOP',
        [Keys.KEYBOARD_KEY_TIVO]: 'KEYCODE_TIVO',
        [Keys.KEYBOARD_KEY_UP]: 'KEYCODE_UP',
        [Keys.LG_REMOTE_KEY_CHANNEL_DOWN]: 'KEYCODE_CHANNEL_DOWN',
        [Keys.LG_REMOTE_KEY_CHANNEL_UP]: 'KEYCODE_CHANNEL_UP',
        [Keys.LG_REMOTE_KEY_CODE_COLOR_BLUE]: 'KEYCODE_COLOR_BLUE',
        [Keys.LG_REMOTE_KEY_CODE_MEDIA_FAST_FORWARD]: 'KEYCODE_MEDIA_FAST_FORWARD',
        [Keys.LG_REMOTE_KEY_CODE_MEDIA_PAUSE]: 'KEYCODE_MEDIA_PAUSE',
        [Keys.LG_REMOTE_KEY_CODE_MEDIA_PLAY]: 'KEYCODE_MEDIA_PLAY',
        [Keys.LG_REMOTE_KEY_CODE_MEDIA_REWIND]: 'KEYCODE_MEDIA_REWIND',
        [Keys.LG_REMOTE_KEY_CODE_MEDIA_STOP]: 'KEYCODE_MEDIA_STOP',
        [Keys.LG_REMOTE_KEY_CODE_RETURN]: 'KEYCODE_RETURN',
        [Keys.SAMSUNG_REMOTE_KEY_0]: 'KEYCODE_NUM_0',
        [Keys.SAMSUNG_REMOTE_KEY_1]: 'KEYCODE_NUM_1',
        [Keys.SAMSUNG_REMOTE_KEY_2]: 'KEYCODE_NUM_2',
        [Keys.SAMSUNG_REMOTE_KEY_3]: 'KEYCODE_NUM_3',
        [Keys.SAMSUNG_REMOTE_KEY_4]: 'KEYCODE_NUM_4',
        [Keys.SAMSUNG_REMOTE_KEY_5]: 'KEYCODE_NUM_5',
        [Keys.SAMSUNG_REMOTE_KEY_6]: 'KEYCODE_NUM_6',
        [Keys.SAMSUNG_REMOTE_KEY_7]: 'KEYCODE_NUM_7',
        [Keys.SAMSUNG_REMOTE_KEY_8]: 'KEYCODE_NUM_8',
        [Keys.SAMSUNG_REMOTE_KEY_9]: 'KEYCODE_NUM_9',
        [Keys.SAMSUNG_REMOTE_KEY_CHANNEL_DOWN]: 'KEYCODE_CHANNEL_DOWN',
        [Keys.SAMSUNG_REMOTE_KEY_CHANNEL_UP]: 'KEYCODE_CHANNEL_UP',
        [Keys.SAMSUNG_REMOTE_KEY_COLOR_BLUE]: 'KEYCODE_COLOR_BLUE',
        [Keys.SAMSUNG_REMOTE_KEY_EXIT]: 'KEYCODE_EXIT',
        [Keys.SAMSUNG_REMOTE_KEY_GUIDE]: 'KEYCODE_GUIDE',
        [Keys.SAMSUNG_REMOTE_KEY_MEDIA_FAST_FORWARD]: 'KEYCODE_MEDIA_FAST_FORWARD',
        [Keys.SAMSUNG_REMOTE_KEY_MEDIA_INFO]: 'KEYCODE_MEDIA_INFO',
        [Keys.SAMSUNG_REMOTE_KEY_MEDIA_PAUSE]: 'KEYCODE_MEDIA_PAUSE',
        [Keys.SAMSUNG_REMOTE_KEY_MEDIA_PLAY_PAUSE]: 'KEYCODE_MEDIA_PLAY_PAUSE',
        [Keys.SAMSUNG_REMOTE_KEY_MEDIA_PLAY]: 'KEYCODE_MEDIA_PLAY',
        [Keys.SAMSUNG_REMOTE_KEY_MEDIA_REWIND]: 'KEYCODE_MEDIA_REWIND',
        [Keys.SAMSUNG_REMOTE_KEY_MEDIA_STOP]: 'KEYCODE_MEDIA_STOP',
        [Keys.SAMSUNG_REMOTE_KEY_RETURN]: 'KEYCODE_RETURN',
    };

    /**
     * Instance member of the key object.
     */
    public code: number;

    public type: string;

    public key: string;

    public keyCode: string;

    constructor(keyEvent: CustomKeyPressedEvent) {
        this.code = keyEvent.code;
        this.key = keyEvent.key.toLowerCase();
        this.type = keyEvent.type;
        this.keyCode =
            keyEvent.key === 'Unidentified'
                ? Keys.KEYCODES[this.code]
                : Keys.KEYCODES[this.key] || 'KEYCODE_UNKNOWN';
    }
}
